import React, { useEffect, useRef, useState } from "react";
import { TextField, Button, IconButton, Badge } from "@mui/material";
import io from "socket.io-client";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import styles from "../styles/videoComponent.module.css";
import CallEndIcon from "@mui/icons-material/CallEnd";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import ScreenShareIcon from "@mui/icons-material/ScreenShare";
import StopScreenShareIcon from "@mui/icons-material/StopScreenShare";
import ChatIcon from "@mui/icons-material/Chat";
import { useNavigate } from "react-router-dom";
import server from "../environment";

const server_url = server;

var connections = {};

const peerConfigConnections = {
    iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
};

export default function VideoMeetComponent() {
    var socketRef = useRef();
    let socketIdRef = useRef();

    let localVideoRef = useRef();

    let [videoAvailable, setVideoAvailable] = useState(true);
    let [audioAvailable, setAudioAvailable] = useState(true);
    let [video, setVideo] = useState([]);
    let [audio, setAudio] = useState();
    let [screen, setScreen] = useState();
    let [showModal, setModal] = useState(true);
    let [screenAvailable, setScreenAvailable] = useState();
    let [messages, setMessages] = useState([]);
    let [message, setMessage] = useState("");
    let [newMessages, setNewMessages] = useState(3);
    let [askForUsername, setAskForUsername] = useState(true);
    let [username, setUsername] = useState("");
    let [videos, setVideos] = useState([]);

    // const videoRef = useRef([]);

    let routeTo = useNavigate();

    function isChromium() {
        return !!window.chrome;
    }

    const hasRedirected = useRef(false);

    useEffect(() => {
        if (hasRedirected.current) return;

        if (!isChromium()) {
            hasRedirected.current = true;
            alert("This feature works best in Chromium-based browsers.");
            routeTo("/", { replace: true });
        }
    }, []);

    const getPermissions = async () => {
        try {
            const videoPermission = await navigator.mediaDevices.getUserMedia({
                video: true,
            });
            if (videoPermission) {
                setVideoAvailable(true);
            } else {
                setVideoAvailable(false);
            }

            const audioPermission = await navigator.mediaDevices.getUserMedia({
                audio: true,
            });
            if (audioPermission) {
                setAudioAvailable(true);
            } else {
                setAudioAvailable(false);
            }

            if (navigator.mediaDevices.getDisplayMedia) {
                setScreenAvailable(true);
            } else {
                setScreenAvailable(false);
            }

            if (videoAvailable || audioAvailable) {
                const userMediaStream =
                    await navigator.mediaDevices.getUserMedia({
                        video: videoAvailable,
                        audio: audioAvailable,
                    });
                if (userMediaStream) {
                    window.localStream = userMediaStream;
                    if (localVideoRef.current) {
                        localVideoRef.current.srcObject = userMediaStream;
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getPermissions();
    }, []);

    let getUserMediaSuccess = (stream) => {
        try {
            window.localStream.getTracks().forEach((track) => track.stop());
        } catch (e) {
            console.log(e);
        }

        window.localStream = stream;
        localVideoRef.current.srcObject = stream;
        for (let id in connections) {
            if (id === socketIdRef.current) continue;
            window.localStream.getTracks().forEach((track) => {
                connections[id].addTrack(track, window.localStream);
            });
            connections[id].createOffer().then((description) => {
                connections[id]
                    .setLocalDescription(description)
                    .then(() => {
                        socketRef.current.emit(
                            "signal",
                            id,
                            JSON.stringify({
                                sdp: connections[id].localDescription,
                            })
                        );
                    })
                    .catch((e) => console.log(e));
            });
        }

        stream.getTracks().forEach(
            (track) =>
                (track.onended = () => {
                    setVideo(false);
                    setAudio(false);
                    try {
                        let tracks =
                            localVideoRef.current.srcObject.getTracks();
                        tracks.forEach((track) => track.stop());
                    } catch (e) {
                        console.log(e);
                    }

                    let blackSlience = (...args) =>
                        new MediaStream([black(...args), silence()]);
                    window.localStream = blackSlience();
                    localVideoRef.current.srcObject = window.localStream;

                    for (let id in connections) {
                        window.localStream.getTracks().forEach((track) => {
                            connections[id].addTrack(track, window.localStream);
                        });
                        connections[id].createOffer().then((description) => {
                            connections[id]
                                .setLocalDescription(description)
                                .then(() => {
                                    socketRef.current.emit(
                                        "signal",
                                        id,
                                        JSON.stringify({
                                            sdp: connections[id]
                                                .localDescription,
                                        })
                                    );
                                })
                                .catch((e) => console.log(e));
                        });
                    }
                })
        );
    };

    let silence = () => {
        let ctx = new AudioContext();
        let oscillator = ctx.createOscillator();

        let dst = oscillator.connect(ctx.createMediaStreamDestination());
        oscillator.start();
        ctx.resume();
        return Object.assign(dst.stream.getAudioTracks()[0], {
            enabled: false,
        });
    };

    let black = ({ width = 640, height = 480 } = {}) => {
        let canvas = Object.assign(document.createElement("canvas"), {
            width,
            height,
        });
        canvas.getContext("2d").fillRect(0, 0, width, height);
        let stream = canvas.captureStream();
        return Object.assign(stream.getVideoTracks()[0], { enabled: false });
    };

    let getUserMedia = () => {
        if ((video && videoAvailable) || (audio && audioAvailable)) {
            navigator.mediaDevices
                .getUserMedia({ video: video, audio: audio })
                .then(getUserMediaSuccess)
                .then((stream) => {})
                .catch((e) => console.log(e));
        } else {
            try {
                let tracks = localVideoRef.current.srcObject.getTracks();
                tracks.forEach((track) => track.stop());
            } catch (e) {}
        }
    };

    useEffect(() => {
        if (video !== undefined && audio !== undefined) {
            getUserMedia();
        }
    }, [video, audio]);

    // TODO
    let gotMessageFromServer = (fromId, message) => {
        var signal = JSON.parse(message);
        if (fromId !== socketIdRef.current) {
            if (signal.sdp) {
                connections[fromId]
                    .setRemoteDescription(new RTCSessionDescription(signal.sdp))
                    .then(() => {
                        if (signal.sdp.type === "offer") {
                            connections[fromId]
                                .createAnswer()
                                .then((description) => {
                                    connections[fromId]
                                        .setLocalDescription(description)
                                        .then(() => {
                                            socketRef.current.emit(
                                                "signal",
                                                fromId,
                                                JSON.stringify({
                                                    sdp: connections[fromId]
                                                        .localDescription,
                                                })
                                            );
                                        })
                                        .catch((e) => console.log(e));
                                })
                                .catch((e) => console.log(e));
                        }
                    })
                    .catch((e) => console.log(e));
            }
            if (signal.ice) {
                connections[fromId]
                    .addIceCandidate(new RTCIceCandidate(signal.ice))
                    .catch((e) => console.log(e));
            }
        }
    };

    const addMessage = (data, sender, socketIdSender) => {
        setMessages((prevMessages) => [
            ...prevMessages,
            { sender: sender, data: data },
        ]);
        if (socketIdSender !== socketIdRef.current) {
            setNewMessages((prevNewMessages) => prevNewMessages + 1);
        }
    };

    let connectToSocketServer = () => {
        socketRef.current = io.connect(server_url, { secure: false });

        socketRef.current.on("signal", gotMessageFromServer);

        socketRef.current.on("connect", () => {
            socketRef.current.emit("join-call", window.location.href);
            socketIdRef.current = socketRef.current.id;
            socketRef.current.on("chat-message", addMessage);
            socketRef.current.on("user-left", (id) => {
                setVideos((videos) =>
                    videos.filter((video) => video.socketId !== id)
                );
            });
            socketRef.current.on("user-joined", (id, clients) => {
                clients.forEach((socketListId) => {
                    connections[socketListId] = new RTCPeerConnection(
                        peerConfigConnections
                    );
                    connections[socketListId].onicecandidate = (event) => {
                        if (event.candidate !== null) {
                            socketRef.current.emit(
                                "signal",
                                socketListId,
                                JSON.stringify({ ice: event.candidate })
                            );
                        }
                    };
                    connections[socketListId].ontrack = (event) => {
                        if (event.track.kind !== "video") return;

                        const remoteStream = event.streams[0];

                        setVideos((prevVideos) => {
                            const alreadyExists = prevVideos.find(
                                (v) => v.socketId === socketListId
                            );

                            if (alreadyExists) {
                                return prevVideos.map((v) =>
                                    v.socketId === socketListId
                                        ? { ...v, stream: remoteStream }
                                        : v
                                );
                            }

                            return [
                                ...prevVideos,
                                {
                                    socketId: socketListId,
                                    stream: remoteStream,
                                },
                            ];
                        });
                    };
                    if (window.localStream) {
                        window.localStream.getTracks().forEach((track) => {
                            connections[socketListId].addTrack(
                                track,
                                window.localStream
                            );
                        });
                    } else {
                        let blackSlience = (...args) =>
                            new MediaStream([black(...args), silence()]);
                        window.localStream = blackSlience();
                        window.localStream.getTracks().forEach((track) => {
                            connections[socketListId].addTrack(
                                track,
                                window.localStream
                            );
                        });
                    }
                });
                if (id === socketIdRef.current) {
                    for (let id2 in connections) {
                        if (id2 === socketIdRef.current) continue;

                        try {
                            connections[id2].addstream(window.localStream);
                        } catch (e) {}

                        connections[id2].createOffer().then((description) => {
                            connections[id2]
                                .setLocalDescription(description)
                                .then(() => {
                                    socketRef.current.emit(
                                        "signal",
                                        id2,
                                        JSON.stringify({
                                            sdp: connections[id2]
                                                .localDescription,
                                        })
                                    );
                                })
                                .catch((e) => console.log(e));
                        });
                    }
                }
            });
        });
    };

    let getMedia = () => {
        setVideo(videoAvailable);
        setAudio(audioAvailable);

        connectToSocketServer();
    };

    let connect = () => {
        setAskForUsername(false);
        getMedia();
    };

    let handleVideo = () => {
        setVideo(!video);
    };

    let handleAudio = () => {
        setAudio(!audio);
    };

    let getDisplayMediaSuccess = (stream) => {
        try {
            window.localStream.getTracks().forEach((track) => track.stop());
        } catch (e) {
            console.log(e);
        }
        window.localStream = stream;
        localVideoRef.current.srcObject = stream;

        for (let id in connections) {
            if (id === socketIdRef.current) continue;
            window.localStream.getTracks().forEach((track) => {
                connections[id].addTrack(track, window.localStream);
            });
            connections[id].createOffer().then((description) => {
                connections[id]
                    .setLocalDescription(description)
                    .then(() => {
                        socketRef.current.emit(
                            "signal",
                            id,
                            JSON.stringify({
                                sdp: connections[id].localDescription,
                            })
                        );
                    })
                    .catch((e) => console.log(e));
            });
        }
        stream.getTracks().forEach(
            (track) =>
                (track.onended = () => {
                    setScreen(false);
                    try {
                        let tracks =
                            localVideoRef.current.srcObject.getTracks();
                        tracks.forEach((track) => track.stop());
                    } catch (e) {
                        console.log(e);
                    }

                    let blackSlience = (...args) =>
                        new MediaStream([black(...args), silence()]);
                    window.localStream = blackSlience();
                    localVideoRef.current.srcObject = window.localStream;

                    getUserMedia();
                })
        );
    };
    let getDisplayMedia = () => {
        if (screen) {
            if (navigator.mediaDevices.getDisplayMedia) {
                navigator.mediaDevices
                    .getDisplayMedia({ video: true, audio: true })
                    .then(getDisplayMediaSuccess)
                    .then((stream) => {})
                    .catch((e) => console.log(e));
            }
        }
    };

    useEffect(() => {
        if (screen !== undefined) {
            getDisplayMedia();
        }
    }, [screen]);

    let handleScreen = () => {
        setScreen(!screen);
    };

    let sendMessage = () => {
        socketRef.current.emit("chat-message", message, username);
        setMessage("");
    };

    let handleEndCall = () => {
        try {
            let tracks = localVideoRef.current.srcObject.getTracks();
            tracks.forEach((track) => track.stop());
        } catch (e) {}

        routeTo("/home");
    };

    return (
        <div>
            {askForUsername === true ? (
                <div className={styles.previewRoot}>
                    <div className={styles.previewCard}>
                        <div className={styles.previewVideo}>
                            <video
                                ref={localVideoRef}
                                autoPlay
                                muted
                                playsInline
                            />
                        </div>

                        <TextField
                            fullWidth
                            size="medium"
                            label="Your name"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            InputProps={{
                                style: {
                                    color: "white",
                                    WebkitTextFillColor: "white",
                                    caretColor: "white",
                                },
                            }}
                            InputLabelProps={{
                                style: {
                                    color: "rgba(255,255,255,0.7)",
                                },
                            }}
                        />

                        <Button
                            variant="contained"
                            size="large"
                            className={styles.joinBtn}
                            onClick={connect}
                        >
                            Join meeting
                        </Button>
                    </div>
                </div>
            ) : (
                <div className={styles.meetingRoot}>
                    <div
                        className={`${styles.videoArea} ${
                            showModal ? "" : styles.full
                        }`}
                    >
                        {videos.map((video) => (
                            <div
                                key={video.socketId}
                                className={styles.remoteVideo}
                            >
                                <video
                                    ref={(ref) => {
                                        if (ref && video.stream) {
                                            ref.srcObject = video.stream;
                                        }
                                    }}
                                    autoPlay
                                />
                            </div>
                        ))}
                    </div>

                    <video
                        className={styles.selfVideo}
                        ref={localVideoRef}
                        autoPlay
                        muted
                    />

                    {showModal && (
                        <div
                            className={`${styles.chatPanel} ${
                                showModal ? styles.open : ""
                            }`}
                        >
                            <h2>Chat</h2>

                            <div className={styles.chatMessages}>
                                {messages.length > 0 ? (
                                    messages.map((item, index) => (
                                        <div key={index}>
                                            <strong>{item.sender}</strong>
                                            <p>{item.data}</p>
                                        </div>
                                    ))
                                ) : (
                                    <p>No Messages Yet</p>
                                )}
                            </div>

                            <div className={styles.chatInput}>
                                <TextField
                                    fullWidth
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    label="Message"
                                />
                                <Button
                                    onClick={sendMessage}
                                    variant="contained"
                                >
                                    Send
                                </Button>
                            </div>
                        </div>
                    )}

                    <div className={styles.controlsBar}>
                        <IconButton
                            className={`${styles.controlBtn} ${
                                video ? styles.active : styles.off
                            }`}
                            onClick={handleVideo}
                        >
                            {video ? <VideocamIcon /> : <VideocamOffIcon />}
                        </IconButton>

                        <IconButton
                            className={`${styles.controlBtn} ${
                                audio ? styles.active : styles.off
                            }`}
                            onClick={handleAudio}
                        >
                            {audio ? <MicIcon /> : <MicOffIcon />}
                        </IconButton>

                        <IconButton
                            className={`${styles.controlBtn} ${styles.endCall}`}
                            onClick={handleEndCall}
                        >
                            <CallEndIcon />
                        </IconButton>

                        {screenAvailable && (
                            <IconButton
                                className={`${styles.controlBtn} ${
                                    screen
                                        ? styles.screenActive
                                        : styles.screenBtn
                                }`}
                                onClick={handleScreen}
                            >
                                {screen ? (
                                    <StopScreenShareIcon />
                                ) : (
                                    <ScreenShareIcon />
                                )}
                            </IconButton>
                        )}

                        <Badge badgeContent={newMessages} color="secondary">
                            <IconButton
                                className={`${styles.controlBtn} ${
                                    showModal
                                        ? styles.chatActive
                                        : styles.chatBtn
                                }`}
                                onClick={() => setModal(!showModal)}
                            >
                                <ChatIcon />
                            </IconButton>
                        </Badge>
                    </div>
                </div>
            )}
        </div>
    );
}
